<div class="new-enquiry-page">
  <!-- Header -->
  <header class="page-header">
    <div class="header-toolbar">
      <button class="back-button" (click)="router.navigate(['/dashboard'])">
        <i class="fas fa-arrow-left"></i>
      </button>
      <h1 class="page-title">Add new bulk enquiry</h1>
      
      <div class="new-location-select" *ngIf="locations.length > 0">
        <label for="location-select" class="location-label"><i class="fas fa-map-marker-alt"></i> Location</label>
        <select 
          id="location-select"
          class="custom-select location-dropdown"
          [(ngModel)]="selectedLocation"
          (change)="onLocationChange($event)"
        >
          <option value="">Select Location</option>
          <option *ngFor="let location of locations" [value]="location.branchId">
            {{ location.branchName }}
          </option>
        </select>
      </div>
    </div>
  </header>

  <div class="page-content" *ngIf="isModalSubmitted">
    <div class="auth">
      <form class="form" [formGroup]="registerForm" (ngSubmit)="onSubmit()">

        <!-- Vehicle Make Selection -->
        <ng-container>
          <!-- Left: Make Selection (Simplified) -->
          <div class="vehicle-selection-center-wrapper" *ngIf="!isVehicleDetailsFullySelected()">
            <div class="vehicle-selection-container">
              <!-- Make Selection Panel -->
              <div class="selection-options-panel" style="width: 100%; max-width: 100%;">
                <div class="panel-header">
                  <span class="header-title">Select Car Brand</span>
                </div>

                <div class="panel-content">
                  <!-- Make Selection -->
                  <div class="options-grid">
                    <div class="option-card" 
                         *ngFor="let make of makeList" 
                         (click)="selectBrandStep(make)"
                         [class.selected]="selectedVehicle.make === make.title">
                      <div class="brand-icon" *ngIf="make.icon" [style.background-position]="make.icon"></div>
                      <div class="brand-image" *ngIf="!make.icon && make.img_path">
                        <img [src]="make.img_path" [alt]="make.title">
                      </div>
                      <div class="brand-icon-fallback" *ngIf="!make.icon && !make.img_path">
                        <i class="fas fa-car"></i>
                      </div>
                      <span class="option-text">{{ make.title }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Vehicle Details Summary (After make selection) -->
          <div class="vehicle-details-summary" *ngIf="isVehicleDetailsFullySelected()">
            <div class="card vehicle-details-card">
              <div class="card-header">
                <i class="fas fa-car"></i>
                <span>Vehicle Details</span>
              </div>

              <!-- Vehicle Display Section -->
              <div class="vehicle-display-section mx-5 my-2">
                <div class="vehicle-info">
                  <div class="vehicle-header">
                    <div class="vehicle-icon-badge">
                      <i class="fas fa-car"></i>
                    </div>
                    <div class="vehicle-details">
                      <h3 class="vehicle-title">
                        {{ selectedVehicle.make }}
                        <span class="variant-badge">Bulk Enquiry</span>
                      </h3>
                      <div class="vehicle-specs">
                        <span class="spec-item">
                          <i class="fas fa-boxes"></i>
                          Multiple Parts
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Vehicle Attachments -->
              <!-- <div class="attachment-section mx-5 my-2">
                
                <div class="attachment-section-title">
                  <i class="fas fa-paperclip"></i>
                  <span>Vehicle Related Documents or Pictures</span>
                </div>

                <div class="attachment-header">
                  <select 
                    class="attachment-type-select"
                    (change)="onUploadTypeChange($event)"
                  >
                    <option value="">Select Attachment Type</option>
                    <option *ngFor="let item of vehicleDocList" [value]="item.id">
                      {{ item.value }}
                    </option>
                  </select>
                  <button type="button" class="upload-button" (click)="newVehicleAttachment()">
                    Upload
                  </button>
                </div>

                <table class="attachment-table" *ngIf="vehicleAttachmentList.length > 0">
                  <thead>
                    <tr>
                      <th>Type</th>
                      <th>Option</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let attachment of vehicleAttachmentList; let i = index; trackBy: trackByFn">
                      <td>{{ getAttachmentValue(attachment.attachmentType) }}</td>
                      <td class="actions">
                        <button  type="button" class="icon-button" (click)="showVehicleAttachment(i,attachment)">
                          <i class="fas fa-eye"></i>
                        </button>
                        <button type="button" class="icon-button delete" (click)="removeVehicleAttachment(i, attachment.attachmentId)">
                          <i class="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div> -->
            </div>

            <!-- Shared Bulk Upload / Manual Entry Logic -->
            <ng-container *ngIf="isBulkupload; else manualEntryBlock">
              <ng-container *ngTemplateOutlet="bulkUploadBlock"></ng-container>
            </ng-container>
          </div>

        </ng-container>

        <!-- Manual Entry Section -->
        <ng-template #manualEntryBlock>
          <ng-container *ngTemplateOutlet="manualEntryTable"></ng-container>
        </ng-template>

        <ng-template #bulkUploadBlock>
          <div class="card upload-section shadow border-0 rounded-4 overflow-hidden">
            
            <!-- Header -->
            <!-- <div class="card-header d-flex align-items-center bg-gradient bg-success text-white p-3">
              <i class="fas fa-file-excel fa-lg"></i>
              <h4 class="mb-0">Upload Parts via Excel</h4>
            </div> -->
           
             <div class="part-details-card">
                <div class="card-header">
                   <i class="fas fa-tools"></i>
                   <span>Parts Details</span>
                </div>
            </div>
        
            <!-- Body -->
            <div class="card-body p-4">

              <div class="d-flex align-items-center gap-2 mb-3">
                <button 
                  class="btn btn-primary btn-sm px-3 py-2 d-flex align-items-center" 
                  (click)="downloadTemplate()" 
                  title="Download Excel Template"
                  type="button"
                >
                  <i class="fas fa-arrow-down me-2"></i>
                  <span>Download Excel Template</span>
                </button>
              </div>
              
              <!-- Line 2: Upload -->
              <div class="d-flex align-items-center gap-3 mb-3">
                <input #fileInput type="file" accept=".xlsx,.xls" hidden (change)="handleFileChange($event)" />
              
                <button 
                  class="btn btn-success btn-sm px-3 py-2 d-flex align-items-center" 
                  (click)="fileInput.click()"
                  title="Select Excel File"
                  type="button"
                >
                  <i class="fas fa-upload me-2"></i>
                  <span>Select File</span>
                </button>
              </div>
              
              <div *ngIf="selectedExcelFile" class="d-flex align-items-center gap-2 mb-3">
                <span class="badge bg-secondary d-flex align-items-center text-truncate" style="max-width: 160px;">
                  <i class="fas fa-file-excel me-1"></i>
                  {{ selectedExcelFile.name }}
                </span>
                <button 
                  class="btn btn-link text-danger p-0 text-start" 
                  (click)="clearSelectedExcelFile()" 
                  type="button" 
                  title="Remove selected file"
                >
                  <i class="fas fa-times-circle fa-lg"></i>
                </button>
              <button
                  class="btn btn-success"
                  (click)="onExcelUpload()"
                  [disabled]="!selectedExcelFile"
                  type="button"
                >
                  <i class="fas fa-upload me-2"></i>Upload
                </button>
              </div>

              <div class="pt-4 border-top">
                  <ng-container *ngTemplateOutlet="manualEntryTable"></ng-container>
              </div>
               
            </div>
          </div>
        </ng-template>

        <!-- Parts Table (Reused for both manual/bulk entry) -->
        <ng-template #manualEntryTable>
          <div class="card parts-details-card">
            <!-- <div class="card-header">
              <i class="fas fa-tools"></i>
              <span>Parts Details</span>
            </div> -->
            <table class="parts-table">
              <thead>
                <tr>
                  <th style="width: 20%; text-align: center;">Part No</th>
                  <th style="width: 50%; text-align: center;">Description</th>
                  <th style="width: 15%; text-align: center;">Qty</th>
                  <th style="width: 15%; text-align: center;">Opt</th>
                </tr>
              </thead>
              <tbody formArrayName="partDetails">
                <tr *ngFor="let part of partDetails.controls; let i = index" [formGroupName]="i">
                  <td style="width: 20%;">
                    <input type="text" formControlName="partNo" class="input-field" />
                  </td>
                  <td style="position: relative; width: 50%;">
                    <input 
                      type="text" 
                      formControlName="partDescription" 
                      class="input-field" 
                      (input)="onPartDescriptionInput($event, i)"
                      (blur)="hideSuggestions(i)"
                      (focus)="onPartDescriptionInput($event, i)"
                      autocomplete="off"
                    />
                    
                    <!-- Autocomplete suggestions dropdown -->
                    <div 
                      class="autocomplete-suggestions" 
                      *ngIf="showSuggestions[i] && partDescriptionSuggestions.length > 0"
                    >
                      <div 
                        *ngFor="let suggestion of partDescriptionSuggestions" 
                        class="suggestion-item"
                        (mousedown)="selectPartDescription(suggestion, i)"
                      >
                        {{ suggestion.full_description || suggestion.description || suggestion.itemDescription || suggestion }}
                      </div>
                    </div>
                    <div class="error-text" *ngIf="getPartError(i, 'partDescription')">
                       {{ getPartError(i, 'partDescription') }}
                    </div>
                  </td>
                  <td style="width: 15%;">
                    <input type="number" formControlName="qty" class="input-field" (keypress)="allowOnlyNumbers($event)"
                     (input)="onQtyInput(i)"
                    />
      
                      <div class="error-text" *ngIf="getPartError(i, 'qty')">
                        {{ getPartError(i, 'qty') }}
                      </div>
                  </td>
                  <td class="actions" style="width: 15%;">
                    <button type="button" class="icon-button" *ngIf="!part.value.partAttachmentId" (click)="addPartImage(i)">
                      <i class="fas fa-paperclip"></i>
                    </button>
                    <button type="button" class="icon-button" *ngIf="part.value.partAttachmentId" (click)="showPartDetailsAttachment(i, part)">
                      <i class="fas fa-eye"></i>
                    </button>
                    <button type="button" class="icon-button delete" *ngIf="i !== 0" (click)="removePart(i)">
                      <i class="fas fa-trash"></i>
                    </button>
                    <!-- Info icon for definition -->
                    <span class="info-icon-wrapper" *ngIf="part.value.partDefinition">
                      <i class="fas fa-info-circle info-icon"></i>
                      <span class="definition-tooltip">{{ part.value.partDefinition }}</span>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="form-actions d-flex justify-content-between align-items-center mt-3">
              <button class="btn btn-outline-primary" type="button" (click)="addPart()">
                <i class="fas fa-plus me-2"></i>
                <span>Add Line Item</span>
              </button>

              <button class="btn btn-success" type="submit" [disabled]="isLoading || !isAnyPartFilled">
                <div class="spinner" *ngIf="isLoading"></div>
                <span>Submit</span>
              </button>
            </div>
          </div>
        </ng-template>


      </form>
    </div>
  </div>
</div>

<ng-template #excelPreviewModal let-modal>
  <form #excelForm="ngForm" (ngSubmit)="confirmExcelData(excelForm, modal)" novalidate>
    <div class="modal-header">
      <h5 class="modal-title">Preview Excel Data</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>

    <div class="modal-body">
      <table class="table table-bordered table-striped table-sm">
        <thead>
          <tr>
            <th>Part No</th>
            <th>Description</th>
            <th>Qty <span class="text-danger">*</span></th>
            <th>Opt</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of excelPreview; let i = index">
            <td>
              <input
              [(ngModel)]="row.partNo"
              name="partno{{i}}"
              class="form-control"
            />
            </td>
            <td>
              <input
                [(ngModel)]="row.partDescription"
                name="desc{{i}}"
                class="form-control"
              />
              <div class="text-danger small" *ngIf="excelForm.submitted && !row.partDescription?.trim() && !row.partNo?.trim()">
                Enter Part No or Description
              </div>
            </td>
            <td>
              <input
                type="number"
                [(ngModel)]="row.qty"
                name="qty{{i}}"
                class="form-control"
                (keypress)="allowOnlyNumbers($event)"
                required
              />
              <div class="text-danger small" *ngIf="excelForm.submitted && isInvalidQty(row.qty)">
                Qty is required
              </div>
            </td>
            <td class="actions">
              <button type="button" class="btn btn-link text-danger p-0" (click)="removeExcelPreviewRow(i)">
                <i class="fas fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
      <button type="submit" class="btn btn-primary">
        Confirm & Patch
      </button>
    </div>
  </form>
</ng-template>
